export const content = {
        title : 'Meet the team',
        subtitle: 'We\'re building the Hash Protocol network',
        text: 'Our team has deep experience building and scaling blockchains from projects like Ethereum, Cosmos and Harmony.<br/><br/>We are on a mission to change the way that blockchains and decentralized applications are built—making them more secure, scalable and sovereign. We envision a world where global communities have the power to self-organize without being burdened by existing power structures.',
        menus: [
            {
                id : 'team',
                text: 'Team'
            },{
                id : 'advisors',
                text: 'Advisors'
            },
        ]
    }

export const FooterBoxes = [
    {
        title: 'Join our growing community',
        text: 'Be part of our growing community of developers and innovators who are helping build the Hash Protocol network.',
        button: {
            text: 'Help build Hash Protocol',
            href: '/join-our-community',
            id: 'operator',
            type: 'simple'
        }
    },
    {
        title: 'Build on our developer beta',
        text: 'Build on Hash Protocol and be the first to explore the benefits of its novel architecture.',
        button: {
            text: 'Join the waitlist',
            href: '#',
            id: 'developer',
            type: 'modal'
        }
    }
]

export const anchors = [
    {
        text: 'Team',
        anchor: 'team'
    },{
        text: 'Advisors',
        anchor: 'advisors'
    },
]
